import { RM09_04 } from "./RM09_04";

export const RM09_03 = {
  selectedValueColumn: "DrillKey",
  selectedTitle: "Territory",
  visual: [
    {
      columns: 12,
      rows: 2,
      visual: {
        id: 1,
        type: "advancedTable",
        colorTheme: "colorTheme1",
        title: "Territory",
        binding: {
          data: {
            columns: [
              {
                name: "Territory",
                columnName: "TerritoryName",
                width: "450px",
                align: "left",
                sortable: true
              },
              {
                name: "Agent Name",
                columnName: "AgentName",
                width: "450px",
                align: "left",
                sortable: true
              },
              {
                name: "Completed",
                columnName: "CompletedAccounts",
                width: "180px",
                align: "center",
                sortable: true
              },
              {
                name: "Total Accounts",
                columnName: "TotalAccounts",
                width: "180px",
                align: "center",
                sortable: true
              },
              {
                name: "Call Frequency",
                columnName: "CallFrequency",
                width: "180px",
                align: "center",
                sortable: true,
                percent: true
              },
            ],
            title: "TerritoryName",
            endpoint: "SFE_RM09.3",
            parameters: [
              { key: "CycleCode", value: "CP1" },
              { key: "CycleYear", value: "2026" },
              { key: "RegionCode", value: "2026" },
              { key: "DrillKey", value: "" },
            ],
          },
          context: {
            point: {
              onClick: RM09_04,
            },
          },
        },
      },
    },
  ],
};